/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/cardproperties/questionproperties/questionformat/questionformat_styles';



/* ========== ~~~~~~~~~~ EMEBD QUESTION FORMAT ~~~~~~~~~~ ========== */
const QuestionFormat = (props) => {

	const handleSelected = () => {
		if (props.selectedType !== props.type) {
			props.setSelectedContentProperty(true, 'type', props.type);
		}
	}

	const phase = props.selectedType === props.type ? 'active' : 'inactive';

	return (
		<div className={`questionformat ${props.classes.questionformat} ${props.type} ${phase}`} onClick={handleSelected}>
			<div className={`visual`} />
			<div className={`desc`}>
				<div className={`icon`} />
				<div className={`text`}>{props.desc}</div>
			</div>
		</div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(QuestionFormat);
